module.exports = __webpack_public_path__ + "static/media/close_button.c0a237bb.svg";